import {
  IMPORT_PRODUCTS,
  IMPORT_PRODUCTS_SUCCESS,
  IMPORT_PRODUCTS_FAILURE,
  GET_PRODUCTS_DATA,
  GET_PRODUCTS_DATA_SUCCESS,
  GET_PRODUCTS_DATA_FAILURE,
  ADD_PRODUCT,
  ADD_PRODUCT_SUCCESS,
  ADD_PRODUCT_FAILURE,
  UPDATE_PRODUCT,
  UPDATE_PRODUCT_SUCCESS,
  UPDATE_PRODUCT_FAILURE,
  DELETE_PRODUCT,
  DELETE_PRODUCT_SUCCESS,
  DELETE_PRODUCT_FAILURE
} from '../actions/productActions';


const INITIAL_STATE = {
  products: {
    data: {},
    status: null,
    error: null,
    loading: false,
  },
  import: {
    log: null,
    status: null,
    error: null,
    loading: false,
  },
  created: {
    product: null,
    status: null,
    error: null,
    loading: false,
  },
  updated: {
    product: null,
    status: null,
    error: null,
    loading: false,
  },
  deleted: {
    product: null,
    status: null,
    error: null,
    loading: false,
  }
};


export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case IMPORT_PRODUCTS:
      return { ...state, import: { log: null, status: 'importing', error: null, loading: true } };
    case IMPORT_PRODUCTS_SUCCESS:
      return { ...state, import: { log: action.payload.log, status: 'imported', error: null, loading: false } };
    case IMPORT_PRODUCTS_FAILURE:
      return { ...state, import: { log: null, status: 'not-imported', error: action.payload.error, loading: false } };

    // case GET_PRODUCTS_DATA:
    //   return { ...state, products: { data: [], status: 'fetching', error: null, loading: true } };
    // case GET_PRODUCTS_DATA_SUCCESS:
    //   return { ...state, products: { data: action.payload.products, status: 'fetched', error: null, loading: false } };
    // case GET_PRODUCTS_DATA_FAILURE:
    //   return { ...state, products: { data: [], status: 'not-fetched', error: action.payload.error, loading: false } };

    case GET_PRODUCTS_DATA:
      return { ...state, products: { data: state.products.data, status: 'fetching', error: null, loading: true, cancel: false } };
    case GET_PRODUCTS_DATA_SUCCESS:
      if (state.products.cancel) return state;
      if (action.payload.reset) {
        return { ...state, products: { data: { [action.payload.page.key]: action.payload.page.items }, status: 'fetched', error: null, loading: false, cancel: false } };
      }
      return { ...state, products: { data: { ...state.products.data, [action.payload.page.key]: action.payload.page.items }, status: 'fetched', error: null, loading: false, cancel: false } };
    case GET_PRODUCTS_DATA_FAILURE:
      return { ...state, products: { data: state.products.data, status: 'not-fetched', error: action.payload.error, loading: false, cancel: false } };
    
    case ADD_PRODUCT:
      return { ...state, created: { product: null, status: 'creating', error: null, loading: true } };
    case ADD_PRODUCT_SUCCESS:
      return { ...state, created: { product: action.payload.product, status: 'created', error: null, loading: false } };
    case ADD_PRODUCT_FAILURE:
      return { ...state, created: { product: null, status: 'not-created', error: action.payload.error, loading: false } };

    case UPDATE_PRODUCT:
      return { ...state, updated: { product: null, status: 'updating', error: null, loading: true } };
    case UPDATE_PRODUCT_SUCCESS:
      return { ...state, updated: { product: action.payload.product, status: 'updated', error: null, loading: false } };
    case UPDATE_PRODUCT_FAILURE:
      return { ...state, updated: { product: null, status: 'not-updated', error: action.payload.error, loading: false } };

    case DELETE_PRODUCT:
      return { ...state, deleted: { product: null, status: 'deleting', error: null, loading: true } };
    case DELETE_PRODUCT_SUCCESS:
      return { ...state, deleted: { product: action.payload.product, status: 'deleted', error: null, loading: false } };
    case DELETE_PRODUCT_FAILURE:
      return { ...state, deleted: { product: null, status: 'not-deleted', error: action.payload.error, loading: false } };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/productReducer.js